import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cb_form_text = _resolveComponent("cb-form-text")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_cb_form_text, {
        "cb-type": "PHARMACY_GROUP_PUBLIC_NAME",
        mode: _ctx.PageDetailModeEnum.EDIT,
        title: _ctx.$t('pharmacyGroup'),
        description: _ctx.$t('descriptions.pharmacyGroup')
      }, null, 8, ["mode", "title", "description"])
    ]),
    _: 1
  }))
}